import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Quote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Frase del día — rota cada 24h, misma frase para todos los usuarios.
 * Se muestra debajo del logo del calendario.
 */
export default function QuoteOfTheDay() {
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/stoic-quotes/today`)
      .then(res => { if (!cancelled) setQuote(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!quote || !quote.frase) return null;

  return (
    <div
      className="quote-of-day-card mt-3 max-w-md bg-gradient-to-br from-gray-900/80 to-gray-800/60 border-l-4 border-gold rounded-r-lg px-3 py-2 backdrop-blur-sm"
      data-testid="quote-of-the-day"
    >
      <div className="flex items-start gap-2">
        <Quote className="quote-of-day-icon h-4 w-4 text-gold flex-shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="quote-of-day-text text-white text-sm sm:text-base italic leading-snug">
            “{quote.frase}”
          </p>
          {quote.autor && (
            <p className="quote-of-day-author text-gold/70 text-[11px] sm:text-xs mt-1 uppercase tracking-wide font-semibold">
              — {quote.autor}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
